import ListCollection from 'types/redux/ListCollection';

import Job from 'models/Job';
import JobAgreement from 'models/JobAgreement';
import JobCategory from 'models/JobCategory';
import JobExperience from 'models/JobExperience';
import JobLanguage from 'models/JobLanguage';
import JobMode from 'models/JobMode';
import JobTime from 'models/JobTime';

import { Filters } from 'components/modules/public/pages/Jobs/types';

import Component from './component';

export interface Props {
    jobCategories?: JobCategory[];
    jobAgreements?: JobAgreement[];
    jobModes?: JobMode[];
    jobExperiences?: JobExperience[];
    jobLanguages?: JobLanguage[];
    jobTimes?: JobTime[];

    onClearFilters: (keys: string[]) => void;
    onClearAll: () => void;

    translations: {
        title: {
            label: string;
            default: string;
            withValues: string;
        };
        filters: {
            sort: {
                label: string;
                tooltip?:string;
                options: {
                    relevant: string;
                    newest: string,
                    last3Days: string,
                    last7Days:string,
                    salary: string,
                }
            }
        }
        options: {
            save: {
                label: string;
            }
        }
    };

    searchParams: any;
    onChangeSearchParam: (key: string, value: any, clean?: boolean) => void;

    onSearch: any;
    collection: ListCollection<Job>;
}

Component.defaultProps = {};

export default Component;